import React from 'react';
import StackCustom from "../../general_components/StackCustom";
import Page from "../../general_components/Page";
import ConstantsList from "./components/ConstantsList";

function Constants(props) {
    return (
        <Page title="Riviera SkyGarden | Constants" style={{paddingBottom: '6vh'}}>
            <StackCustom
                text="Constants"
                isText={true}
                child={null}
            />
            <ConstantsList/>
        </Page>
    );
}

export default Constants;